<template>
  <v-card tile flat>
    <v-card-text class="px-0">
      <v-alert dense colored-border border="left" color="blue" class="bg-notif mb-0 body-2" v-if="withAction">
        <v-row no-gutters align="center">
          <v-col class="grow"> Ubah/Lengkapi {{ title }}</v-col>
          <v-col class="shrink">
            <v-btn depressed small color="info" dark @click="onEdit">
              <v-icon small v-text="'mdi-pencil'"></v-icon> Ubah/Lengkapi
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <base-list-info class="px-0" :info="info"></base-list-info>
    </v-card-text>
  </v-card>
</template>
<script>
import BaseListInfo from '@/components/base/BaseListInfo';
export default {
  name: 'CvInfo',
  components: { BaseListInfo },
  props: {
    info: {
      type: Array,
      required: true,
    },
    status: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    withAction: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit', { type: this.type });
    },
  },
};
</script>

<style scoped>
.bg-notif {
  background-color: rgb(187, 222, 251) !important;
}
</style>
